import * as yup from "yup";

export const mapAttachmentToFileItem = ({ id, name, fileUrl }) => ({
  uid: id,
  name,
  status: "done",
  url: fileUrl,
});

/**
 * Maps stored attachments to recto/verso form fields, with legacy CIN fallback.
 */
export const resolveIdentityDocumentSides = (
  attachments,
  { rectoType, versoType, legacyType },
) => {
  const rectoAttachments = attachments.filter((att) => att.type === rectoType);
  const versoAttachments = attachments.filter((att) => att.type === versoType);
  const legacyAttachments = attachments.filter(
    (att) => att.type === legacyType,
  );

  if (rectoAttachments.length || versoAttachments.length) {
    return {
      recto: rectoAttachments.map(mapAttachmentToFileItem),
      verso: versoAttachments.map(mapAttachmentToFileItem),
    };
  }

  return {
    recto: legacyAttachments.slice(0, 1).map(mapAttachmentToFileItem),
    verso: legacyAttachments.slice(1, 2).map(mapAttachmentToFileItem),
  };
};

export const requiredIdentitySideSchema = (messages) =>
  yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string().required(messages.REQUIRED),
      }),
    )
    .required(messages.REQUIRED_ATTACHMENT)
    .min(1, messages.REQUIRED_ATTACHMENT);
